<template>
  <div class="single-tracking-info card-1">
     <span :class="{active: index == 0}"></span>
     <section class="main-data">
       <h3>{{ index + 1}}. {{ data.description }}</h3>
       <h4>{{ data.dateTime}}</h4>
       <h5>Timezone: {{ data.timezone}}</h5>
     </section>
     <a href="" @click.prevent="showAddress = !showAddress">Toggle Address Info</a>
     <section class="address-info" v-show="showAddress">
       <div><strong>City: </strong>{{data.address.city ? data.address.city : "Not Found" }}</div>
       <div><strong>State:</strong> {{data.address.state ? data.address.state : "Not Found"}}</div>
       <div><strong>Country:</strong> {{data.address.country ? data.address.country : "Not Found"}}</div>
       <div><strong>Zip:</strong> {{data.address.postCode ? data.address.postCode : "Not Found"}}</div>
     </section>
  </div>
</template>

<script>
  export default {
     props: ['data', 'index'],
     data(){
       return {
         showAddress: false
       }
     }
  }
</script>

<style lang="scss" scoped>
  @keyframes radar {
     0%{
       transform: scale(1);
       opacity: 0;
     }
     30%{
       transform: scale(1);
       opacity: 1;
     }
     80%{
       transform: scale(2);
       opacity: 0;
     }
     100%{
       transform: scale(1);
       opacity: 0;
     }
  }
  .single-tracking-info{
    flex-basis: 300px;
    flex-grow: 0;
    flex-shrink: 0;
    border-radius: 5px;
    background-color: rgb(236, 236, 236);
    box-shadow: 
    7px 7px 15px rgba(55, 84, 170,.15),
    -7px -7px 20px rgba(255, 255, 255,1),
    inset 0px 0px 4px rgba(255, 255, 255,.2);
    margin: 0 15px;
    padding: 20px;
    position: relative;
    $blueTrackingLineColor: #394650;
    $lightBlueLineColor: #1991EB;
    &:last-child::after{
       width: 0;
    }
    &::after{
      content: "";
      left: 50%;
      top: -20px;
      height: 2px;
      width: 100%;
      background-color: $blueTrackingLineColor;
      position: absolute;
    }
    span{
      display: block;
      left: 50%;
      transform: translate(-200%, -40%);
      top: -20px;
      height: 3px;
      width: 10px;
      height: 10px;
      background-color: $lightBlueLineColor;
      position: absolute;
      border-radius: 50%;


      
      &::after{
        display: block;
        position: absolute;
        border: 1px solid $lightBlueLineColor;
        content: "";
        left: -3px;
        top: -3px;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        
      }
      &.active::after{
        animation: radar 2s infinite;
      }
    }
    a{
      font-size: 13px;
    }

  }
  .main-data{
    h3{
      font-size: 18px;
    }
    h4, h5{
      font-size: 14px;
      color: rgb(150, 150, 150);
    }
    
  }
  .address-info{
    div{
      font-size: 13px;
    }
  }
</style>